export interface Locale {
    id: string;
    name: string;
}

export const LOCALES: Locale[] = [
    {
        id: 'en-CA',
        name: 'English (Canada)',
    },
    {
        id: 'fr-CA',
        name: 'Français (Canada)',
    },
    {
        id: 'en-US',
        name: 'English (US)',
    },
    {
        id: 'en-GB',
        name: 'English (United Kingdom)',
    },
    {
        id: 'es',
        name: 'Español',
    },
];

export const VENDOR_LOCALES: Locale[] = [
    ...LOCALES,
    {
        id: 'ru',
        name: 'Русский',
    },
    {
        id: 'uk',
        name: 'Українська',
    },
];
